import { DoDisturbAltOutlined } from '@mui/icons-material';
import { Stack, Typography } from '@mui/material';

export default function NoUpdates({ isExpired }: { isExpired?: boolean }) {
  return (
    <Stack
      spacing={0.5}
      alignItems="center"
      justifyContent="center"
      padding={4}
    >
      <DoDisturbAltOutlined sx={{ color: '#686868' }} />
      <Typography variant="h6" fontWeight="500" color="#686868">
        {isExpired
          ? 'These changes are no longer available as the post has expired.'
          : 'No changes have been detected.'}
      </Typography>
    </Stack>
  );
}
